import React, { useState } from 'react';

export default function Accordion({ items }) {
  const [openIndex, setOpenIndex] = useState(0);

  if (!items || items.length === 0) return null;

  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="space-y-3">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div
            key={index}
            className="bg-white rounded-xl border border-[#228A47]/15 overflow-hidden transition-all duration-200"
          >
            <button
              type="button"
              onClick={() => toggleItem(index)}
              className="w-full px-6 py-4 text-left font-semibold text-[#062364] flex items-center justify-between gap-4 cursor-pointer hover:bg-[#f4efe6]/50 focus:outline-none focus:ring-2 focus:ring-[#228A47]"
              aria-expanded={isOpen}
            >
              <span className="text-base sm:text-lg">{item.question}</span>
              <span className="w-8 h-8 rounded-full bg-[#e8f5ed] text-[#228A47] flex items-center justify-center shrink-0 transition-transform duration-200">
                <i
                  className={`fa-regular ${isOpen ? 'fa-minus' : 'fa-plus'}`}
                  aria-hidden="true"
                ></i>
              </span>
            </button>

            <div
              className={`grid transition-[grid-template-rows] duration-300 ease-in-out ${
                isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
              }`}
            >
              <div className="overflow-hidden">
                <div className="px-6 pb-5 pt-6 text-sm text-[#132038] leading-relaxed border-t border-[#f4efe6]">
                  {item.answer}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
